module.exports = __webpack_public_path__ + "837dc0008a0d0af018e0abfcc83fea3f.svg";